import React, { useEffect } from "react";

import MasterBrokerTable from "./MasterBrokerTable";
import MasterBrokerAdd from "./MasterBrokerAdd";
import MasterBrokerEdit from "./MasterBrokerEdit";

import Breadcrumbs from "../../../components/ui/Breadcrumbs";
import DeleteAlert from "../../../components/ui/DeleteAlert";

import useApiNew from "../../../utils/useApiNew";

import { errorNotify, successNotify } from "../../../Services/Notification";

import axios from "axios";
import { actionPermissions } from "../../../components/authNavigation/AuthNavbar";

const getAllBrokerApiURL = `${process.env.REACT_APP_API_URL}api/get-all-brokers`;
const brokerApiURL = `${process.env.REACT_APP_API_URL}api/broker`;
const exportBrokerApiURL = `${process.env.REACT_APP_API_URL}api/export-broker`;

const MasterBroker = () => {
  const [renderKey, setRenderKey] = React.useState(0);
  const [isAdd, setIsAdd] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);
  const [isDelete, setIsDelete] = React.useState(false);
  const [selectedItemId, setSelectedItemId] = React.useState();
  const [isLoading, setIsLoading] = React.useState(false);
  const [data, setData] = React.useState();
  const [globalFilters, setGlobalFilters] = React.useState();
  const [isButtonClicked, setIsButtonClicked] = React.useState();
  const [isDownloadClicked, setIsDownloadClicked] = React.useState();

  const name = "broker";
  const triggerRerender = () => {
    setRenderKey((prevKey) => prevKey + 1);
  };

  // API CONFIG
  const headers = {
    Authorization: `Bearer ${
      sessionStorage.getItem("subscriberToken")
        ? sessionStorage.getItem("subscriberToken")
        : sessionStorage.getItem("token")
    }`,
    "Content-Type": "application/json",
  };

  const { data: bankDatas, loading } = useApiNew(
    getAllBrokerApiURL,
    "GET",
    { headers },
    renderKey,
  );

  const bankData = bankDatas?.map((item) => ({
    ...item,
    status: item.status ? "Active" : "Inactive",
  }));

  useEffect(() => {
    if (bankData) {
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
  }, [bankData]);

  const filterBankData = () => {
    let filterData = bankData;
    if (globalFilters) {
      filterData = bankData.filter(
        (item) =>
          item?.name?.toLowerCase().includes(globalFilters?.toLowerCase()) ||
          item?.short_name
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.status?.toLowerCase() === globalFilters?.toLowerCase(),
      );
    }
    setData(filterData);
  };
  useEffect(() => {
    filterBankData();
  }, [globalFilters]);

  // ADD

  const addBrokerApiOptions = {
    headers: {
      Authorization: `Bearer ${
        sessionStorage.getItem("subscriberToken")
          ? sessionStorage.getItem("subscriberToken")
          : sessionStorage.getItem("token")
      }`,
      "Content-Type": "multipart/form-data",
    },
    timeout: 60000 * 20,
  };

  const handleAddBroker = async (data) => {
    setIsButtonClicked(true);
    try {
      const res = await axios.post(`${brokerApiURL}/`, data, addBrokerApiOptions);
      const resData = res.data;
      triggerRerender();

      if (!resData.error) {
        successNotify("Data added.");
        setIsButtonClicked(false);
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return false;
    }
  };

  // EDIT
  const handleEditBroker = async (segmentId, data) => {
    setIsButtonClicked(true);
    const updateAPI = `${brokerApiURL}/${segmentId}`;

    try {
      const res = await axios.put(updateAPI, data, addBrokerApiOptions);
      const resData = res.data;
      triggerRerender();

      if (!resData.error) {
        successNotify("Data saved.");
        setIsButtonClicked(false);
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return false;
    }
  };

  // DELETE

  const handleDeleteBroker = async () => {
    const deleteAPI = `${brokerApiURL}/${selectedItemId}`;
    try {
      const res = await axios.delete(deleteAPI, { headers });
      const resData = res.data;
      triggerRerender();
      if (!resData.error) {
        successNotify("Data deleted.");
        setIsDelete(false);
        return true;
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      return false;
    }
  };

  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().slice(0, 10);

  const downloadExcel = async (filename) => {
    try {
      const apiEndpoint = exportBrokerApiURL;
      const headers = {
        Authorization: `Bearer ${
          sessionStorage.getItem("subscriberToken")
            ? sessionStorage.getItem("subscriberToken")
            : sessionStorage.getItem("token")
        }`,
      };
      const response = await axios.get(apiEndpoint, {
        headers,
        responseType: "blob",
      });

      if (response && response.data) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename; // Set the filename here

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        setIsDownloadClicked(false);
      } else {
        console.error("Invalid response or missing data");
        setIsDownloadClicked(false);
      }
    } catch (error) {
      errorNotify("Something went wrong.");
      setIsDownloadClicked(false);
    }
  };

  // EXPORT
  const downloadBroker = () => {
    setIsDownloadClicked(true);
    const filename = `Broker-Master_${formattedDate}.xlsx`;
    downloadExcel(filename);
  };

  const breadcrumbs = ["Home", "Master", "Broker"];

  const buttonConfig = {
    value: "broker",
    name: "Broker",
    addHandler: handleAddBroker,
    editHandler: handleEditBroker,
    deleteHandler: handleDeleteBroker,
    downloadHandler: downloadBroker,
    closeAddModal: () => setIsAdd(false),
    closeEditModal: () => setIsEdit(false),
  };

  // if (!bankData) return null;

  return (
    <div className=" app-container min-h-[65vh] pb-[60px] pt-[100px]">
      <Breadcrumbs items={breadcrumbs} />
      <MasterBrokerTable
        tableData={globalFilters ? data : bankData}
        buttonConfig={buttonConfig}
        bankDatas={bankDatas}
        setIsAdd={setIsAdd}
        setIsEdit={setIsEdit}
        setIsDelete={setIsDelete}
        setSelectedItemId={setSelectedItemId}
        renderKey={renderKey}
        isLoading={isLoading}
        loading={loading}
        setGlobalFilters={setGlobalFilters}
        actionPermissions={actionPermissions("masters", "Broker")}
        isDownloadClicked={isDownloadClicked}
      />
      {isAdd && <MasterBrokerAdd buttonConfig={buttonConfig} isButtonClicked={isButtonClicked} />}
      {isEdit && (
        <MasterBrokerEdit
          buttonConfig={buttonConfig}
          selectedItemId={selectedItemId}
          isButtonClicked={isButtonClicked}
        />
      )}
      {isDelete && (
        <DeleteAlert
          closeHandler={() => setIsDelete(false)}
          deleteHandler={buttonConfig.deleteHandler}
        />
      )}
    </div>
  );
};

export default MasterBroker;
